import {
    Button,
    Grid,
    Row,
    Col,
    FormGroup,
    FormControl,
    ControlLabel,
    Table,
} from "react-bootstrap";
import Loader from "../Loader";
import QuestionModal from "../QuestionModal";
import React, { PureComponent } from "react";
import { StyleSheet, css } from "aphrodite";
import * as colors from "../../styles/colors";
import * as managers from "../../lib/api/managers";
import logger from "../../lib/logger";

const styles = StyleSheet.create({
    imageWrapper: {
        textAlign: "center",
        width: 90,
    },
    editWrapper: {
        textAlign: "center",
        width: 80,
    },
    verticalCenter: {
        verticalAlign: "middle",
        fontSize: 16,
    },
    error: {
        color: colors.red,
    },
});

const strings = {
    title: "Questions | Habit CMS",
    question: "Question",
    numComplete: "# Complete",
    edit: "Edit",
    enterText: "Enter Text",
    filterByQuestion: "Filter by Question:",
    add: "Add",
    managers: "managers",
    total: "total",
};

export default class QuestionsPage extends PureComponent {
    state = {
        loading: true,
        filter: "",
        questions: [],
        showQuestionModal: false,
        currentQuestion: null,
    };

    componentDidMount() {
        this._isMounted = true;
        document.title = strings.title;
        managers
            .getQuestions()
            .then(resp => {
                if (this._isMounted) {
                    this.setState({
                        questions: resp.questions,
                        loading: false,
                    });
                }
            })
            .catch(err => {
                logger.warn(err);
                if (this._isMounted) {
                    this.setState({
                        loading: false,
                    });
                }
            });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    _editQuestion = q => {
        this.setState({
            showQuestionModal: true,
            currentQuestion: q,
        });
    };

    _addQuesiton = () => {
        this.setState({
            showQuestionModal: true,
            currentQuestion: null,
        });
    };

    _handleCloseQuestionModal = () => {
        this.setState({
            showQuestionModal: false,
        });
    };

    _handleDeleteQuestion = () => {
        managers.deleteQuestion(this.state.currentQuestion.id).then(() => {
            this.setState({
                showQuestionModal: false,
                questions: this.state.questions.filter(q => q.id !== this.state.currentQuestion.id),
            });
        });
    };

    _handleAddQuestion = question => {
        managers.addQuestion(question).then(q => {
            this.setState({
                showQuestionModal: false,
                questions: this.state.questions.concat(q),
            });
        });
    };

    _handleUpdateQuestion = question => {
        managers.editQuestion(this.state.currentQuestion.id, question).then(() => {
            this.setState({
                showQuestionModal: false,
                questions: this.state.questions.map(q => {
                    if (q.id === this.state.currentQuestion.id) {
                        return {
                            ...q,
                            question,
                        };
                    }
                    return q;
                }),
            });
        });
    };

    _onFilterChange = e => {
        this.setState({
            filter: e.target.value,
        });
    };

    render() {
        const lowerFilter = this.state.filter.toLowerCase();
        const currentQuestions = this.state.questions.filter(
            q => q.question.toLowerCase().indexOf(lowerFilter) !== -1,
        );
        return (
            <Grid>
                <Row>
                    <Col md={6}>
                        <FormGroup controlId="question">
                            <ControlLabel>{strings.filterByQuestion}</ControlLabel>
                            <FormControl
                                type="text"
                                value={this.state.filter}
                                placeholder={strings.enterText}
                                onChange={this._onFilterChange}
                            />
                        </FormGroup>
                    </Col>
                    <Col mdOffset={5} md={1}>
                        <Button bsStyle="primary" onClick={this._addQuesiton}>
                            {strings.add}
                        </Button>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>{strings.question}</th>
                                    <th>{strings.numComplete}</th>
                                    <th>{strings.edit}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentQuestions.map((q, i) => {
                                    return (
                                        <tr key={i}>
                                            <td className={css(styles.verticalCenter)}>
                                                {q.question}
                                            </td>
                                            <td className={css(styles.verticalCenter)}>
                                                <div>{`${q.managerCount} ${strings.managers}`}</div>
                                                <div>{`${q.totalCount} ${strings.total}`}</div>
                                            </td>
                                            <td
                                                className={css(
                                                    styles.verticalCenter,
                                                    styles.editWrapper,
                                                )}
                                            >
                                                <Button
                                                    bsStyle="primary"
                                                    onClick={() => this._editQuestion(q)}
                                                >
                                                    {strings.edit}
                                                </Button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                        {this.state.loading ? <Loader /> : null}
                    </Col>
                </Row>
                <QuestionModal
                    key={this.state.currentQuestion ? this.state.currentQuestion.id : null}
                    show={this.state.showQuestionModal}
                    initialQuestion={
                        this.state.currentQuestion ? this.state.currentQuestion.question : ""
                    }
                    handleClose={this._handleCloseQuestionModal}
                    handleSave={
                        this.state.currentQuestion
                            ? this._handleUpdateQuestion
                            : this._handleAddQuestion
                    }
                    handleDelete={this._handleDeleteQuestion}
                />
            </Grid>
        );
    }
}
